import axios from './axios.service'
import authHeader from './auth-header'

const token = authHeader()

class JobAplication {
  async getJobAplicationFormOption () {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/create/job`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async getAll (queryData) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/web/jobaplication`,
        { headers: token, params: { ...queryData } }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async getJobAplicationInformation (id) {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/web/jobaplication/${id}`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateStatus (rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/web/jobaplication/update/status/${rowClicked.id}`,
        headers: { Authorization: token.Authorization },
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteJobAplication (rowClicked) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/web/jobaplication/${rowClicked.id || rowClicked}`,
        { headers: token }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async deleteJobAplicationLpgd (id, data) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/web/lgpd/jobaplication/${id}`,
        { headers: token, params: { ...data } }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async storeJobAplication (data) {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/web/jobaplication`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateJobAplication (id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/web/jobaplication/${id}`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}

export default new JobAplication()
